import React from 'react';
import { Link } from 'react-router-dom';
import { business, navigation } from '../data/site';
export function Footer() {
  return <footer className="bg-forest-dark text-cream" data-id="element-18" data-mp="3ggtx2ezk5d3n">
      <div className="mx-auto grid max-w-7xl gap-12 px-5 py-16 md:grid-cols-12 md:px-8" data-id="element-19" data-mp="32o4c8dvrme84">
        <div className="md:col-span-5" data-id="element-20" data-mp="36pfvm1o1q37v">
          <p className="font-serif text-3xl" data-id="element-21" data-mp="36q9354utwwr2">{business.name}</p>
          <p className="mt-2 text-cream/70" data-id="element-22" data-mp="3ufa5cad2jbnw">{business.activity}</p>
          <address className="mt-6 not-italic leading-relaxed text-cream/80" data-id="element-23" data-mp="3ucxok0j1r7cf">
            {business.street}
            <br data-id="element-24" data-mp="36d44znhyxod" />
            {business.postalCode} {business.city}
          </address>
        </div>

        <nav aria-label="Pied de page" className="md:col-span-3" data-id="element-25" data-mp="3lgonkhff80o6">
          <h2 className="text-sm font-medium text-cream/60" data-id="element-26" data-mp="3qbvm7atu2f68">Pages</h2>
          <ul className="mt-4 space-y-2" data-id="element-27" data-mp="29yxcxcohlklt">
            {navigation.map(item => <li key={item.to} data-id="element-28" data-mp="2eyt6sj3gzvnn">
                <Link to={item.to} className="text-cream/90 transition-colors duration-150 hover:text-white" data-id="element-29" data-mp="2ez1ja9vokyyb">
                  {item.label}
                </Link>
              </li>)}
          </ul>
        </nav>

        <div className="md:col-span-4" data-id="element-30" data-mp="3gcjywzp6sgl4">
          <h2 className="text-sm font-medium text-cream/60" data-id="element-31" data-mp="3v89dics1lrft">Entreprise</h2>
          <dl className="mt-4 space-y-2 text-cream/90" data-id="element-32" data-mp="3v5dhitzr9cu0">
            <div className="flex gap-2" data-id="element-33" data-mp="3q7u3nv6yz22l">
              <dt className="text-cream/60" data-id="element-34" data-mp="3qaznow0qrdrg">SIREN</dt>
              <dd data-id="element-35" data-mp="81pexhlx8v8u">{business.siren}</dd>
            </div>
            <div className="flex gap-2" data-id="element-36" data-mp="3474fms9a7yq">
              <dt className="text-cream/60" data-id="element-37" data-mp="335ujlmz7ril">SIRET</dt>
              <dd data-id="element-38" data-mp="hstrkao4k40i">{business.siret}</dd>
            </div>
          </dl>
        </div>
      </div>

      <div className="border-t border-white/10" data-id="element-39" data-mp="ctqnasfyy1tl">
        <div className="mx-auto flex max-w-7xl flex-col gap-2 px-5 py-6 text-sm text-cream/60 sm:flex-row sm:items-center sm:justify-between md:px-8" data-id="element-40" data-mp="cv1r2s9ez9kp">
          <p data-id="element-41" data-mp="mrwmh2ae4tur">© {new Date().getFullYear()} {business.name}. Tous droits réservés.</p>
          <Link to="/mentions-legales" className="hover:text-cream" data-id="element-42" data-mp="mq3i5tn92lpx">
            Mentions légales
          </Link>
        </div>
      </div>
    </footer>;
}